import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import { removeAlert } from 'app/store/features/alertSlice';

const GlobalAlert = () => {
  const alerts = useSelector((state) => state.alerts);
  const dispatch = useDispatch();

  const handleClose = (id, event, reason) => {
    if (reason === 'clickaway') {
        return;
      }
    dispatch(removeAlert(id));
  };

  return (
    <>
{alerts?.map(({ id, message, severity }, index) => (
  <Snackbar
    key={id}
    open={true}
    autoHideDuration={5000}
    onClose={(event, reason) => handleClose(id, event, reason)}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    sx={{ top: `${30 + index * 60}px !important` }}
  >
    <Alert 
      onClose={(event, reason) => handleClose(id, event, reason)} 
      severity={severity} 
    >
      {message}
    </Alert>
  </Snackbar>
))}

    </>
  );
};

export default GlobalAlert;